"use client";

import { msg } from "@lingui/core/macro";
import { Trans, useLingui } from "@lingui/react/macro";
import { SearchIcon, XIcon } from "lucide-react";
import { useRef } from "react";
import { Input } from "@/components/ui/input";
import { useSidebarSearch } from "./sidebar-search-context";

export function SidebarSearchInput() {
  const { i18n } = useLingui();
  const { query, setQuery } = useSidebarSearch();
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="relative bg-sidebar px-2 pb-2">
      <SearchIcon className="pointer-events-none absolute left-4 top-[calc(50%-0.25rem)] size-3.5 -translate-y-1/2 text-sidebar-foreground/50" />
      <Input
        ref={inputRef}
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Escape") {
            setQuery("");
            inputRef.current?.blur();
          }
        }}
        placeholder={i18n._(msg`Filter...`)}
        className="h-7 rounded-md border-sidebar-border bg-sidebar-accent/40 pl-7 pr-7 text-xs shadow-none placeholder:text-sidebar-foreground/40 focus-visible:ring-1 focus-visible:ring-sidebar-ring"
      />
      {query ? (
        <button
          type="button"
          onClick={() => {
            setQuery("");
            inputRef.current?.focus();
          }}
          className="absolute right-4 top-[calc(50%-0.25rem)] -translate-y-1/2 rounded-sm p-0.5 text-sidebar-foreground/50 hover:text-sidebar-foreground/80"
        >
          <XIcon className="size-3" />
          <span className="sr-only">
            <Trans>Clear search</Trans>
          </span>
        </button>
      ) : null}
    </div>
  );
}

export function SidebarSearchEmpty() {
  const { isFiltering, hasMatches } = useSidebarSearch();
  if (!isFiltering || hasMatches) {
    return null;
  }

  return (
    <div className="flex flex-col items-center gap-2 px-4 py-6 text-sidebar-foreground/50">
      <SearchIcon className="size-5" />
      <p className="text-xs">
        <Trans>No matching projects or views</Trans>
      </p>
    </div>
  );
}
